export default __webpack_public_path__ + "static/media/favicon.263e52ac.ico";